import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { hotlineColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getHotline } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "msisdn",
  "status",
  "last_updated",
];

const HotlineBatch = () => (
  <BatchDetail
    title="Hotline"
    apiGet={__getHotline}
    client={CLIENTS.selectel}
    columnsFactory={hotlineColumns}
    copyKeys={COPY_KEYS}
    exportAction="hotline"
    showTerminate
    getRowPath={(row) => `/selectel/hotline/${row.id}`}
  />
);

export default HotlineBatch;
